// src/pages/Users/Users.tsx

import React from "react";
import { useParams } from "react-router-dom";

const Users: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <div>
      <h1>User Page</h1>
      <p>Details for user with ID: {id}</p>
    </div>
  );
};

export default Users;
